var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { xs: 12, sm: 12, md: 12, lg: 12, xl: 12 } },
            [
              _c(
                "el-card",
                { staticClass: "box-card", attrs: { shadow: "never" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("span", { staticClass: "role-span" }, [
                        _vm._v("选择用户"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { xs: 10, sm: 10, md: 10, lg: 10, xl: 10 } },
                        [
                          _c(
                            "div",
                            { staticClass: "head-container" },
                            [
                              _c("el-input", {
                                staticClass: "filter-item",
                                attrs: {
                                  clearable: "",
                                  size: "small",
                                  placeholder: "输入部门名称搜索",
                                  "prefix-icon": "el-icon-search",
                                },
                                on: { input: _vm.getDeptDatas },
                                model: {
                                  value: _vm.deptName,
                                  callback: function ($$v) {
                                    _vm.deptName = $$v
                                  },
                                  expression: "deptName",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-tree", {
                            attrs: {
                              data: _vm.deptDatas,
                              load: _vm.getDeptDatas,
                              props: _vm.defaultProps,
                              "expand-on-click-node": false,
                              lazy: "",
                            },
                            on: { "node-click": _vm.handleNodeClick },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { xs: 14, sm: 14, md: 14, lg: 14, xl: 14 } },
                        [
                          _c("div", { staticClass: "head-container" }, [
                            _c(
                              "div",
                              [
                                _c("el-input", {
                                  staticClass: "filter-item",
                                  staticStyle: { width: "200px" },
                                  attrs: {
                                    clearable: "",
                                    size: "small",
                                    placeholder: "输入名称或者邮箱搜索",
                                  },
                                  nativeOn: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.crud.toQuery($event)
                                    },
                                  },
                                  model: {
                                    value: _vm.query.blurry,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.query, "blurry", $$v)
                                    },
                                    expression: "query.blurry",
                                  },
                                }),
                                _vm._v(" "),
                                _c("rrOperation"),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.crud.loading,
                                  expression: "crud.loading",
                                },
                              ],
                              ref: "table",
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.crud.data,
                                "highlight-current-row": "",
                              },
                              on: { "current-change": _vm.selectUser },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  prop: "username",
                                  label: "用户名",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  prop: "nickName",
                                  label: "昵称",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  label: "岗位",
                                  width: "110",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return _vm._l(
                                        scope.row.jobs,
                                        function (item) {
                                          return _c(
                                            "el-tag",
                                            {
                                              key: item.id,
                                              attrs: {
                                                type: item.name,
                                                effect: "plain",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(item.name) +
                                                  "\n                      "
                                              ),
                                            ]
                                          )
                                        }
                                      )
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("pagination"),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { xs: 12, sm: 12, md: 12, lg: 12, xl: 12 } },
            [
              _c(
                "el-card",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "box-card",
                  attrs: { shadow: "never" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _vm.userId != 0
                        ? _c("span", { staticClass: "role-span" }, [
                            _vm._v("用户-列表配置"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.deptId != 0
                        ? _c("span", { staticClass: "role-span" }, [
                            _vm._v("部门-列表配置"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userId != 0
                        ? _c(
                            "el-button",
                            {
                              staticClass: "filter-item",
                              staticStyle: {
                                float: "right",
                                padding: "4px 10px",
                              },
                              attrs: { size: "mini", type: "primary" },
                              on: { click: _vm.save },
                            },
                            [_vm._v("保存")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userId != 0
                        ? _c(
                            "el-button",
                            {
                              staticClass: "filter-item",
                              staticStyle: {
                                padding: "4px 10px",
                                "margin-left": "5px",
                              },
                              attrs: { size: "mini" },
                              on: { click: _vm.saveByDept },
                            },
                            [_vm._v("获取权限")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.deptId != 0
                        ? _c(
                            "el-button",
                            {
                              staticClass: "filter-item",
                              staticStyle: {
                                padding: "4px 10px",
                                "margin-left": "5px",
                              },
                              attrs: { size: "mini" },
                              on: { click: _vm.saveByUser },
                            },
                            [_vm._v("推送权限")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.deptId != 0
                        ? _c(
                            "el-button",
                            {
                              staticClass: "filter-item",
                              staticStyle: {
                                float: "right",
                                padding: "4px 10px",
                              },
                              attrs: { size: "mini", type: "primary" },
                              on: { click: _vm.deptSave },
                            },
                            [_vm._v("保存")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "head-container",
                      staticStyle: { height: "1000px" },
                    },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "form",
                          attrs: {
                            model: _vm.form,
                            size: "small",
                            "label-width": "120px",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "推广" } },
                            [
                              _c("treeselect", {
                                staticStyle: { width: "380px" },
                                attrs: {
                                  "load-options": _vm.loadDepts,
                                  normalizer: _vm.normalizer,
                                  options: _vm.depts,
                                  multiple: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.deptDatas0,
                                  callback: function ($$v) {
                                    _vm.deptDatas0 = $$v
                                  },
                                  expression: "deptDatas0",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "客服" } },
                            [
                              _c("treeselect", {
                                staticStyle: { width: "380px" },
                                attrs: {
                                  "load-options": _vm.loadDepts,
                                  normalizer: _vm.normalizer,
                                  options: _vm.depts,
                                  multiple: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.deptDatas1,
                                  callback: function ($$v) {
                                    _vm.deptDatas1 = $$v
                                  },
                                  expression: "deptDatas1",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "资调" } },
                            [
                              _c("treeselect", {
                                staticStyle: { width: "380px" },
                                attrs: {
                                  "load-options": _vm.loadDepts,
                                  normalizer: _vm.normalizer,
                                  options: _vm.depts,
                                  multiple: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.deptDatas12,
                                  callback: function ($$v) {
                                    _vm.deptDatas12 = $$v
                                  },
                                  expression: "deptDatas12",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "门店店长" } },
                            [
                              _c("treeselect", {
                                staticStyle: { width: "380px" },
                                attrs: {
                                  "load-options": _vm.loadDepts,
                                  normalizer: _vm.normalizer,
                                  options: _vm.depts,
                                  multiple: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.deptDatas8,
                                  callback: function ($$v) {
                                    _vm.deptDatas8 = $$v
                                  },
                                  expression: "deptDatas8",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "门店导购" } },
                            [
                              _c("treeselect", {
                                staticStyle: { width: "380px" },
                                attrs: {
                                  "load-options": _vm.loadDepts,
                                  normalizer: _vm.normalizer,
                                  options: _vm.depts,
                                  multiple: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.deptDatas2,
                                  callback: function ($$v) {
                                    _vm.deptDatas2 = $$v
                                  },
                                  expression: "deptDatas2",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "设计主管" } },
                            [
                              _c("treeselect", {
                                staticStyle: { width: "380px" },
                                attrs: {
                                  "load-options": _vm.loadDepts,
                                  normalizer: _vm.normalizer,
                                  options: _vm.depts,
                                  multiple: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.deptDatas9,
                                  callback: function ($$v) {
                                    _vm.deptDatas9 = $$v
                                  },
                                  expression: "deptDatas9",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "设计对接人" } },
                            [
                              _c("treeselect", {
                                staticStyle: { width: "380px" },
                                attrs: {
                                  "load-options": _vm.loadDepts,
                                  normalizer: _vm.normalizer,
                                  options: _vm.depts,
                                  multiple: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.deptDatas10,
                                  callback: function ($$v) {
                                    _vm.deptDatas10 = $$v
                                  },
                                  expression: "deptDatas10",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "设计师" } },
                            [
                              _c("treeselect", {
                                staticStyle: { width: "380px" },
                                attrs: {
                                  "load-options": _vm.loadDepts,
                                  normalizer: _vm.normalizer,
                                  options: _vm.depts,
                                  multiple: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.deptDatas3,
                                  callback: function ($$v) {
                                    _vm.deptDatas3 = $$v
                                  },
                                  expression: "deptDatas3",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "效果图组主管" } },
                            [
                              _c("treeselect", {
                                staticStyle: { width: "380px" },
                                attrs: {
                                  "load-options": _vm.loadDepts,
                                  normalizer: _vm.normalizer,
                                  options: _vm.depts,
                                  multiple: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.deptDatas13,
                                  callback: function ($$v) {
                                    _vm.deptDatas13 = $$v
                                  },
                                  expression: "deptDatas13",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "效果图组对接人" } },
                            [
                              _c("treeselect", {
                                staticStyle: { width: "380px" },
                                attrs: {
                                  "load-options": _vm.loadDepts,
                                  normalizer: _vm.normalizer,
                                  options: _vm.depts,
                                  multiple: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.deptDatas14,
                                  callback: function ($$v) {
                                    _vm.deptDatas14 = $$v
                                  },
                                  expression: "deptDatas14",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "协助设计师" } },
                            [
                              _c("treeselect", {
                                staticStyle: { width: "380px" },
                                attrs: {
                                  "load-options": _vm.loadDepts,
                                  normalizer: _vm.normalizer,
                                  options: _vm.depts,
                                  multiple: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.deptDatas11,
                                  callback: function ($$v) {
                                    _vm.deptDatas11 = $$v
                                  },
                                  expression: "deptDatas11",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "设计中心派单员" } },
                            [
                              _c("treeselect", {
                                staticStyle: { width: "380px" },
                                attrs: {
                                  "load-options": _vm.loadDepts,
                                  normalizer: _vm.normalizer,
                                  options: _vm.depts,
                                  multiple: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.deptDatas4,
                                  callback: function ($$v) {
                                    _vm.deptDatas4 = $$v
                                  },
                                  expression: "deptDatas4",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "设计审单员" } },
                            [
                              _c("treeselect", {
                                staticStyle: { width: "380px" },
                                attrs: {
                                  "load-options": _vm.loadDepts,
                                  normalizer: _vm.normalizer,
                                  options: _vm.depts,
                                  multiple: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.deptDatas5,
                                  callback: function ($$v) {
                                    _vm.deptDatas5 = $$v
                                  },
                                  expression: "deptDatas5",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "下单员" } },
                            [
                              _c("treeselect", {
                                staticStyle: { width: "380px" },
                                attrs: {
                                  "load-options": _vm.loadDepts,
                                  normalizer: _vm.normalizer,
                                  options: _vm.depts,
                                  multiple: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.deptDatas15,
                                  callback: function ($$v) {
                                    _vm.deptDatas15 = $$v
                                  },
                                  expression: "deptDatas15",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "配送" } },
                            [
                              _c("treeselect", {
                                staticStyle: { width: "380px" },
                                attrs: {
                                  "load-options": _vm.loadDepts,
                                  normalizer: _vm.normalizer,
                                  options: _vm.depts,
                                  multiple: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.deptDatas6,
                                  callback: function ($$v) {
                                    _vm.deptDatas6 = $$v
                                  },
                                  expression: "deptDatas6",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "安装" } },
                            [
                              _c("treeselect", {
                                staticStyle: { width: "380px" },
                                attrs: {
                                  "load-options": _vm.loadDepts,
                                  normalizer: _vm.normalizer,
                                  options: _vm.depts,
                                  multiple: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.deptDatas7,
                                  callback: function ($$v) {
                                    _vm.deptDatas7 = $$v
                                  },
                                  expression: "deptDatas7",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer",
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: { click: _vm.crud.cancelCU },
                        },
                        [_vm._v("取消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            loading: _vm.crud.status.cu === 2,
                            type: "primary",
                          },
                          on: { click: _vm.crud.submitCU },
                        },
                        [_vm._v("确认")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }